// extracted by mini-css-extract-plugin
module.exports = {"helpSection":"Explanations_helpSection__1XWU3"};